import { BuildingStatus, UserAction } from 'types/building'

import { Branch } from './Branch'
import { Organization, Role } from './User'

export enum BuildingFormField {
  NAME = 'name',
  CODE = 'code',
  ALIAS_NAME = 'aliasName',
  ZIPCODE = 'zipcode',
  PREF_CODE = 'prefCode',
  CITY_NAME = 'cityName',
  STREET_NAME = 'streetName',
  BUILDING_NAME = 'buildingName',
  BRANCH_ID = 'branchId',
  ORGANIZATION_ID = 'organizationId',
  IMAGE = 'image',
  SITE_AREA = 'siteArea',
  BUILDING_AREA = 'buildingArea',
  TOTAL_FLOOR_AREA = 'totalFloorArea',
  STRUCTURE = 'structure',
  FLOOR_NUMBER = 'floorNumber',
  DESIGNER_NAME = 'designerName',
  ARCHITECT_NAME = 'architectName',
  CONSTRUCTION_PERIOD_START = 'constructionPeriodStart',
  CONSTRUCTION_PERIOD_END = 'constructionPeriodEnd',
  LOCATION = 'location',
  LOGO = 'logo',
  LOGO_LINK = 'logoLink',
  BUSINESS_IMAGE = 'businessImage',
  BUSINESS_DESCRIPTION = 'businessDescription',
  TRIPOD_IMAGE = 'tripodImage',
  DESCRIPTION = 'description',
  S3_PATH = 's3Path'
}

export type ListBuilding = {
  edges: Building[]
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

export type Building = {
  aliasName: string
  architectName: string
  action: UserAction
  branch?: Branch
  buildingArea: number
  buildingName: string
  cityName: string
  code: string
  constructionPeriodEnd: string
  constructionPeriodStart: string
  createdAt: string
  designerName: string
  floorNumber: number
  floors: Floor[]
  id: number
  name: string
  organizationName: string
  organization: Organization
  prefCode: number
  siteArea: number
  status: BuildingStatus
  streetName: string
  structure: string
  totalFloorArea: number
  updatedAt: string
  zipcode: string
  s3Path: string
  thumbnail: string
  latestUpdated: string
  latestEditedBy: LatestEditedBy
  defaultFloor: number
  deletedAt?: string | null
  copyStatus: number
  extraInfo: {
    logo?: string
    logoUrl?: string
    logoLink?: string
    businessImage?: string
    businessImageUrl?: string
    description?: string
    descriptionUrl?: string
    locationUrl?: string
    locationEmbed?: string
    tripodImage?: string
    tripodImageUrl?: string
  }
}

export type Floor = {
  id: number
  name: string
  buildingId: number
  order: number
  createdAt: string
  updatedAt: string
}

export type SharedUser = {
  action: string
  email: string
  id: number
  firstName: string
  lastName: string
  organizationName: string
  organizationId: number | null
  role: Role
  companyName: string
  isChangeAction: boolean
}

export type ListSharedUser = {
  edges: SharedUser[]
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

export type OrgForListBuilding = {
  id: number
  name: string
}

export type ListOrgForListBuilding = {
  edges: OrgForListBuilding[]
  pagination: {
    page: number
    pageSize: number
    total: number
  }
}

export type LatestEditedBy = {
  id: number
  firstName: string
  lastName: string
}
